let AdminService = function (Restangular) {
  const Admin = Restangular.all('admin/admin_user');

  let count = (query) => {
    return Admin.customGET('count', query);
  }

  let save = (admin) => {
    if (admin.save) {
        return admin.save();
    } else {
        return Admin.post(admin);
    }
  }

  let index = (query) => {
    query = query || {};
    query.deleted_at = 'null';
    return Admin.getList(query);
  }

  let load = (query) => {
    query.deleted_at = 'null';
    return new Promise((resolve, reject) => {
        count(query)
        .then(response => {
            let count = response[0];
            index(query)
            .then(data => {
                resolve({count, data});
            })
            .catch(err => {
                reject(err);
            });
        })
        .catch(err => {
            reject(err);
        });
    });
  }

  let show = (id) => {
    return Admin.get(id);
  }

  let destroy = (admin) => {
    admin.deleted_at = moment();
    return admin.save();
  }

  return { load, save, show, destroy } ;
};

AdminService.$inject = ['Restangular'];

export default AdminService;



// WEBPACK FOOTER //
// ./client/app/components/admin/admin.service.js